import React, { ReactElement, useMemo } from 'react';
import { BookingStateContext } from './BookingStateContext';
import { BookingState } from './BookingState';
import { useBookingStorage } from '../booking-storage/UseBookingStorage';
import { BookingStateMapper } from './BookingStateMapper';
import { UseBookingStateContextValue } from './UseBookingStateContextValue';
import { BookingStorage } from '../booking-storage/BookingStorage';

export interface BookingStateContextProps {
  defaultState: BookingState;
  children?: React.ReactNode;
}

export function BookingStateContextProvider({ children, defaultState }: BookingStateContextProps): ReactElement {
  const defaultStorageState = useMemo<BookingStorage>(
    () => BookingStateMapper.MapBookingStateToBookingStorage(defaultState),
    [defaultState],
  );
  const [storageState, setStorageState] = useBookingStorage(defaultStorageState);
  const contextValue = useMemo<UseBookingStateContextValue>(
    () => ({
      bookingState: BookingStateMapper.MapBookingStorageToBookingState(storageState),
      setBookingState: (state: BookingState) => {
        const mappedState = BookingStateMapper.MapBookingStateToBookingStorage(state);

        setStorageState(mappedState);
      },
    }),
    [storageState, setStorageState],
  );

  return <BookingStateContext.Provider value={contextValue}>{children}</BookingStateContext.Provider>;
}
